// cr.js «Моё видео» принимает placement только целым числом: на строке он пишет
// «критические ошибки в конфиге» и не запускает плеер. Из БД (block_id — CharField)
// id приходит строкой, поэтому приводим здесь; число проходит как есть.
export function toPlacementId(value) {
    const id = Number(value);

    return Number.isInteger(id) && id > 0 ? id : null;
}
